// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-editor-wrapper .file-comment-panel .remirror-theme .ProseMirror {
  min-height: 44px;
}

.comment-editor-wrapper .file-comment-panel {
  border-radius: var(--ant-border-radius-sm);
  border: var(--ant-line-width) solid var(--ant-color-border, #1677ff);
  background: var(--ant-input-active-bg, #fff);
  overflow: hidden;
  padding: var(--ant-input-padding-block, 4px) 0 var(--ant-input-padding-block, 4px) 0;
}

.comment-editor-wrapper .file-comment-panel:has(:focus) {
  border: var(--ant-line-width) solid var(--ant-input-active-border-color, #1677ff);
  box-shadow: 0px 0px 0px var(--ant-control-outline-width, 2px) var(--ant-control-outline, rgba(5, 145, 255, 0.1));
}

.comment-editor-wrapper .file-comment-panel p {
  font-size: var(--ant-font-size) !important;
}

.comment-panel-wrapper
  .edit
  .remirror-editor
  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 14px;
  left: 12px;
  transform: translateY(-50%);
  color: var(--cms-color-text-tertiary);
  font-size: calc(var(--cms-font-size) * 1px);
  font-family: var(--cms-font-family);
  content: 'Add a comment...';
}

.reply-comment-wrapper
  .comment-panel-wrapper
  .edit
  .remirror-editor
  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 14px;
  left: 12px;
  transform: translateY(-50%);
  color: var(--cms-color-text-tertiary);
  font-size: calc(var(--cms-font-size) * 1px);
  font-family: var(--cms-font-family);
  content: 'Add a reply...';
}

.comment-panel-actions {
  margin-left: var(--ant-margin-xs);
  height: 24px;
  padding: var(--ant-padding-xxs) var(--ant-padding-xs);
  background-color: var(--ant-color-bg-container);
  border-radius: var(--ant-border-radius-sm);
  gap: var(--ant-padding-xs);
  box-shadow:
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);
}

.replies-section,
.reply-comment-wrapper {
  padding-left: calc(var(--ant-padding) * 1.5) !important;
}

.comment-card-wrapper {
  isolation: isolate;
}

.comment-panel-header > .comment-panel-actions {
  display: none;
}

.comment-card-wrapper:hover
  > .comment-card-layout
  > .comment-panel-header-wrapper
  > .comment-panel-header
  > .comment-panel-actions {
  display: flex;
}

.comment-box.reply.edit {
  border-bottom: 1px solid var(--ant-color-border);
  padding-bottom: var(--ant-padding-xs);
}

.document-reactions {
  margin-bottom: var(--ant-margin-xs);
}

.reaction-button {
  cursor: pointer;
  font-size: 20px;
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 0.5rem;
  transition: transform 0.2s ease-in-out;
}

.reaction-button:hover {
  background-color: var(--ant-color-border-secondary) !important;
  animation: jiggle 1s ease-in-out;
}

@keyframes jiggle {
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(10deg);
  }
  30% {
    transform: rotate(-10deg);
  }
  45% {
    transform: rotate(8deg);
  }
  60% {
    transform: rotate(-8deg);
  }
  75% {
    transform: rotate(4deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EditorSpace/ExtraFeature/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,oEAAoE;EACpE,4CAA4C;EAC5C,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;EACE,iFAAiF;EACjF,gHAAgH;AAClH;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;;;;EAKE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,qDAAqD;EACrD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B;;;wCAGsC;AACxC;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,8DAA8D;EAC9D,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".comment-editor-wrapper .file-comment-panel .remirror-theme .ProseMirror {\n  min-height: 44px;\n}\n\n.comment-editor-wrapper .file-comment-panel {\n  border-radius: var(--ant-border-radius-sm);\n  border: var(--ant-line-width) solid var(--ant-color-border, #1677ff);\n  background: var(--ant-input-active-bg, #fff);\n  overflow: hidden;\n  padding: var(--ant-input-padding-block, 4px) 0 var(--ant-input-padding-block, 4px) 0;\n}\n\n.comment-editor-wrapper .file-comment-panel:has(:focus) {\n  border: var(--ant-line-width) solid var(--ant-input-active-border-color, #1677ff);\n  box-shadow: 0px 0px 0px var(--ant-control-outline-width, 2px) var(--ant-control-outline, rgba(5, 145, 255, 0.1));\n}\n\n.comment-editor-wrapper .file-comment-panel p {\n  font-size: var(--ant-font-size) !important;\n}\n\n.comment-panel-wrapper\n  .edit\n  .remirror-editor\n  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 14px;\n  left: 12px;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-tertiary);\n  font-size: calc(var(--cms-font-size) * 1px);\n  font-family: var(--cms-font-family);\n  content: 'Add a comment...';\n}\n\n.reply-comment-wrapper\n  .comment-panel-wrapper\n  .edit\n  .remirror-editor\n  p:first-child:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 14px;\n  left: 12px;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-tertiary);\n  font-size: calc(var(--cms-font-size) * 1px);\n  font-family: var(--cms-font-family);\n  content: 'Add a reply...';\n}\n\n.comment-panel-actions {\n  margin-left: var(--ant-margin-xs);\n  height: 24px;\n  padding: var(--ant-padding-xxs) var(--ant-padding-xs);\n  background-color: var(--ant-color-bg-container);\n  border-radius: var(--ant-border-radius-sm);\n  gap: var(--ant-padding-xs);\n  box-shadow:\n    0px 6px 16px 0px rgba(0, 0, 0, 0.08),\n    0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n\n.replies-section,\n.reply-comment-wrapper {\n  padding-left: calc(var(--ant-padding) * 1.5) !important;\n}\n\n.comment-card-wrapper {\n  isolation: isolate;\n}\n\n.comment-panel-header > .comment-panel-actions {\n  display: none;\n}\n\n.comment-card-wrapper:hover\n  > .comment-card-layout\n  > .comment-panel-header-wrapper\n  > .comment-panel-header\n  > .comment-panel-actions {\n  display: flex;\n}\n\n.comment-box.reply.edit {\n  border-bottom: 1px solid var(--ant-color-border);\n  padding-bottom: var(--ant-padding-xs);\n}\n\n.document-reactions {\n  margin-bottom: var(--ant-margin-xs);\n}\n\n.reaction-button {\n  cursor: pointer;\n  font-size: 20px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  border-radius: 0.5rem;\n  transition: transform 0.2s ease-in-out;\n}\n\n.reaction-button:hover {\n  background-color: var(--ant-color-border-secondary) !important;\n  animation: jiggle 1s ease-in-out;\n}\n\n@keyframes jiggle {\n  0% {\n    transform: rotate(0deg);\n  }\n  15% {\n    transform: rotate(10deg);\n  }\n  30% {\n    transform: rotate(-10deg);\n  }\n  45% {\n    transform: rotate(8deg);\n  }\n  60% {\n    transform: rotate(-8deg);\n  }\n  75% {\n    transform: rotate(4deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
